import React from 'react';
import DatasetConditionRow from '../containers/DatasetConditionRow';

const DatasetConditionRows = ({
  canEdit,
  category,
  code,
  columns,
  datasetConditions,
  name,
  showCondition,
}) => (
  datasetConditions.map((datasetCondition) => (
    <DatasetConditionRow
      key={`${category}-${code}-${datasetCondition.id}`}
      canEdit={canEdit}
      category={category}
      code={code}
      columns={columns}
      datasetCondition={datasetCondition}
      name={name}
      showCondition={showCondition}
    />
  ))
);

export default DatasetConditionRows;
